import * as Toast from "@radix-ui/react-toast";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import IconClose from "~/assets/icons/close.svg";
import IconToastSuccess from "~/assets/icons/toast-success.svg";
import { BodyMedium } from "~/components/Typography";

export const JustResetPasswordToast = () => {
  const { t } = useTranslation();
  return (
    <Toast.Provider duration={4000}>
      <Toast.Root
        defaultOpen
        type="foreground"
        className={classNames(
          "w-[400px] rounded-lg bg-white pb-4 pl-[68px] pr-13 pt-[18px] drop-shadow-lg",
          "state-open:animate-slide-in-from-right",
          "state-closed:animate-fade-out state-closed:duration-100",
          "swipe-move:translate-x-[var(--radix-toast-swipe-move-x)]",
          "swipe-cancel:translate-x-0 swipe-cancel:transition-transform swipe-cancel:duration-200 swipe-cancel:ease-out",
          "swipe-end:animate-toast-swipe-out-to-right"
        )}
      >
        <Toast.Title asChild>
          <BodyMedium className="mb-1 block text-gray-900">
            {t(
              "webapp.reset_password_toast.title",
              "Successfully changed password"
            )}
          </BodyMedium>
        </Toast.Title>
        <img
          alt=""
          src={IconToastSuccess}
          className="absolute left-4 top-4 h-8 w-8"
        />
        <Toast.Description asChild>
          <BodyMedium className="mb-[10px] block font-normal text-gray-500">
            {t(
              "webapp.reset_password_toast.description",
              "Your password has been changed. You were logged out from all devices."
            )}
          </BodyMedium>
        </Toast.Description>
        <Toast.Action altText="Dismiss" asChild>
          <BodyMedium className="cursor-pointer text-[#667085]">
            {t("webapp.reset_password_toast.dismiss", "Dismiss")}
          </BodyMedium>
        </Toast.Action>
        <Toast.Close className="absolute right-4 top-4">
          <img alt="" src={IconClose} className="h-5 w-5" />
        </Toast.Close>
      </Toast.Root>
      <Toast.Viewport className="fixed right-6 top-6" />
    </Toast.Provider>
  );
};
